<template>
  <div
    class="carousel_arrow"
    :class="[{ next: direction === 'next', prev: direction === 'prev' }, theme]"
  >
    <svg
      width="288"
      height="538"
      viewBox="0 0 288 538"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M281.975 255.3L31.95 5.3C28.575 2.025 23.975 0 18.875 0C8.525 0 0.125003 8.4 0.125003 18.75C0.125003 23.825 2.15001 28.45 5.45001 31.825L242.175 268.575L5.45001 505.3C2.07501 508.7 0 513.375 0 518.525C0 528.9 8.40001 537.3 18.775 537.3C23.925 537.3 28.6 535.225 31.975 531.85L282 281.825C285.375 278.425 287.45 273.75 287.45 268.575C287.45 263.4 285.375 258.725 282 255.325L281.975 255.3Z"
        fill="black"
      />
    </svg>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    direction: {
      default: 'next',
    },
    theme: {
      default: 'light',
    },
  },

  computed: {},

  watch: {},

  methods: {},

  components: {},

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.carousel_arrow {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: var(--chalk) 0% 0% no-repeat padding-box;
  border: 1px solid transparent;
  transition: 0.2s ease all;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;

  &.swiper-button-disabled {
    opacity: 0.5 !important;
    transition: 0.2s ease all;
  }

  svg {
    height: 40px;
    transition: 0.2s ease all;

    path {
      fill: var(--green);
      transition: 0.2s ease all;
    }
  }

  &.next {
    margin-right: 30px;

    @media (max-width: $mobile-xl) {
      margin-right: 0;
    }

    svg {
      width: 25px;
      margin-left: 5px;
    }
  }

  &.prev {
    transform: rotate(180deg);
    margin-left: 30px;

    @media (max-width: $mobile-xl) {
      margin-left: 0;
    }

    svg {
      width: 25px;
      margin-left: 5px;
    }
  }

  &:hover {
    transition: 0.2s ease all;
    background: var(--green);
    border: 1px solid var(--green);

    svg {
      height: 40px;
      transition: 0.2s ease all;

      path {
        fill: var(--dark-purple);
        transition: 0.2s ease all;
      }
    }
  }

  &:focus {
    transition: 0.2s ease all;
    background: var(--chalk);
    border: 1px solid var(--green);
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/CarouselArrow.vue